import React, { useState } from 'react';
// import { images } from '../shared/assets';
import { useSiteSettings, useDestinations } from '../../hooks/useContentful';
import { useOverlayManager } from '../../contexts/OverlayContext';
import { ContentfulText } from '../Contentful';
import { useLocation } from 'react-router-dom';
// import { HandDrawnButton } from '../shared/HandDrawnButton/HandDrawnButton';
// import { HandDrawnCheckbox } from '../shared/HandDrawnCheckbox/HandDrawnCheckbox';
import Icon from '../shared/Icon/Icon';
import { useTranslation } from '../../i18n';
import './Footer.css';

interface FooterProps {
  variant?: 'default' | 'patagonia' | 'atacama' | 'iguazu' | 'santa-catarina' | 'mendoza';
}

const Footer: React.FC<FooterProps> = ({ variant = 'default' }) => {
  // const [isPrivacyChecked, setIsPrivacyChecked] = useState(false);
  const [isDestinationsOpen, setIsDestinationsOpen] = useState(false);
  const [email, setEmail] = useState('');
  // const [isSubmitting, setIsSubmitting] = useState(false);
  // const [submitMessage, setSubmitMessage] = useState('');
  // const [email, setEmail] = useState('');
  const { t } = useTranslation();

  // Dropdown starts closed by default on all devices

  // Fetch data from Contentful
  const { data: siteSettingsData } = useSiteSettings();
  const { data: destinationsData } = useDestinations();
  const siteSettings = siteSettingsData?.[0]?.fields;
  const destinations = destinationsData || [];

  // Get hovered destination from context
  const { overlayState, setHoveredDestination } = useOverlayManager();
  const { hoveredDestination } = overlayState;

  // Determine current variant (hoveredDestination takes precedence for animation)
  const getCurrentVariant = () => {
    // If hovering over a destination, show that variant for smooth animation
    if (hoveredDestination) {
      // Map destination names to variants
      const destinationMap: { [key: string]: 'patagonia' | 'atacama' | 'iguazu' | 'santa-catarina' | 'mendoza' } = {
        'patagonia': 'patagonia',
        'atacama': 'atacama',
        'iguazu': 'iguazu',
        'santa catarina': 'santa-catarina',
        'mendoza': 'mendoza'
      };
      const hoveredVariant = destinationMap[hoveredDestination];
      if (hoveredVariant) {
        return hoveredVariant;
      }
    }

    // Otherwise use the prop variant
    return variant;
  };

  const currentVariant = getCurrentVariant();

  // Determine if we need dark icons (for light backgrounds)
  const needsDarkIcons = currentVariant === 'patagonia';

  // Fix #87 - CRM email signup functionality
  // const handleNewsletterSubmit = async (e: React.FormEvent) => {
  //   e.preventDefault();

  //   if (!email || !isPrivacyChecked) {
  //     setSubmitMessage(t('footer:newsletter.pleaseAcceptPrivacy'));
  //     return;
  //   }

  //   setIsSubmitting(true);
  //   setSubmitMessage('');

  //   try {
  //     // TODO: Replace with actual CRM API endpoint
  //     const response = await fetch('/api/newsletter/subscribe', {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //       },
  //       body: JSON.stringify({
  //         email,
  //         consent: isPrivacyChecked,
  //         source: 'website_footer',
  //         property: variant
  //       }),
  //     });

  //     if (response.ok) {
  //       setSubmitMessage(t('footer:newsletter.successMessage'));
  //       setEmail('');
  //       setIsPrivacyChecked(false);
  //     } else {
  //       setSubmitMessage(t('footer:newsletter.errorMessage'));
  //     }
  //   } catch (error) {
  //     console.error('Newsletter signup error:', error);
  //     setSubmitMessage(t('footer:newsletter.errorMessage'));
  //   } finally {
  //     setIsSubmitting(false);
  //   }
  // };

  // Get the appropriate logo based on current variant
  // const getLogoSrc = () => {
  //   switch (currentVariant) {
  //     case 'iguazu':
  //       return images.footerLogo; // Iguazu logo - white
  //     case 'mendoza':
  //       return images.logoMendozaWhite; // Mendoza logo - white
  //     case 'santa-catarina':
  //       return images.footerLogo; // Santa Catarina logo - white
  //     case 'atacama':
  //       return images.footerLogo; // Awasi logo - white
  //     case 'patagonia':
  //       return images.logoIguazuWhite; // Awasi logo - for light background
  //     default:
  //       return images.footerLogo; // Default Awasi logo
  //   }
  // };

  const location = useLocation();
  const domain = window.location.origin;
  const canonicalUrl = `${domain}${location.pathname}`;

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
  };

  const submitToAll = (e: React.FormEvent) => {
    e.preventDefault();
    // console.log('start');

    // let form = document.getElementById("revinate_contact_api_form");
    // console.log(form);

    // let checkboxes = document.getElementsByName('sendTo');
    // console.log(checkboxes);

    // if (checkboxes)
    //   // @ts-ignore
    //   for (let checkbox of checkboxes) {
    //     if (checkbox.checked && form) {
    //       form.setAttribute('token', checkbox.value);
    //       console.log("revFormOnSubmit");

    //     }
    //   }
    //   if (form) form.removeAttribute('token');
    // @ts-ignore
    revFormOnSubmit();

    // clean form data
    setEmail('');
  }

  return (
    <footer className={`footer footer--${currentVariant}`} style={{ transition: 'background-color 0.3s ease' }}>

      <link rel="canonical" href={canonicalUrl} />

      <div className="footer__inner">

        <div className="footer-item footer-item--destinations">
          <div className="footer-destinations-header" onClick={() => setIsDestinationsOpen(!isDestinationsOpen)}>
            <h2 className="footer-destinations-heading">
              <ContentfulText
                content={siteSettings?.destinationsSectionTitle}
                fallback={t('footer:sections.destinations' as any)}
              />
            </h2>
            <div className={`footer-accordion-icon ${isDestinationsOpen ? 'open' : ''}`}>
              <svg className="footer-accordion-arrow-icon" width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="27" cy="27" r="26" stroke="currentColor" strokeWidth="2" />
                <path d="M20 24l7 7 7-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
          </div>

          <div className={`footer-destinations-dropdown ${isDestinationsOpen ? 'open' : ''}`}>
            {destinations.length > 0 ? (
              destinations
                .filter(d => !d.fields.comingSoon)
                .map((destination) => {
                  const name = String(destination.fields.name || '');
                  const slug = String(destination.fields.slug || name.toLowerCase());
                  return (
                    <a
                      key={destination.sys.id}
                      href={`/${slug}`}
                      onMouseEnter={() => setHoveredDestination(name.toLowerCase())}
                      onMouseLeave={() => setHoveredDestination(null)}
                    >
                      <ContentfulText
                        content={destination.fields.name}
                        fallback={name}
                      />
                    </a>
                  );
                })
            ) : (
              // Fallback destinations
              <>
                <a
                  href="/atacama/"
                  onMouseEnter={() => setHoveredDestination('atacama')}
                  onMouseLeave={() => setHoveredDestination(null)}
                >
                  {t('navigation:atacama' as any)}
                </a>
                <a
                  href="/patagonia/"
                  onMouseEnter={() => setHoveredDestination('patagonia')}
                  onMouseLeave={() => setHoveredDestination(null)}
                >
                  {t('navigation:patagonia' as any)}
                </a>
                <a
                  href="/iguazu/"
                  onMouseEnter={() => setHoveredDestination('iguazu')}
                  onMouseLeave={() => setHoveredDestination(null)}
                >
                  {t('navigation:iguazu' as any)}
                </a>
                <a
                  href="/mendoza/"
                  onMouseEnter={() => setHoveredDestination('mendoza')}
                  onMouseLeave={() => setHoveredDestination(null)}
                >
                  {t('navigation:mendoza' as any)}
                </a>
                <a
                  href="/santa-catarina/"
                  onMouseEnter={() => setHoveredDestination('santa catarina')}
                  onMouseLeave={() => setHoveredDestination(null)}
                >
                  {t('navigation:santaCatarina' as any)}
                </a>
              </>
            )}
          </div>
        </div>

        <div className="footer-item footer-item--links">
          <ul className="footer-links__list">
            <li className="footer-links__item">
              <a href="/contact/">
                <ContentfulText content={siteSettings?.footerContactText} fallback={t('footer:links.contactUs' as any)} />
              </a>
            </li>
            <li className="footer-links__item">
              <a href="https://awasi.hiringroom.com/jobs/" target="_blank">
                <ContentfulText content={siteSettings?.footerCareersText} fallback={t('footer:links.careers' as any)} />
              </a>
            </li>
            {/* <li className="footer-links__item">
              <a href="/sitemap/">
                Sitemap
              </a>
            </li> */}
            {
              /*
            <a href="/assets/Awasi-Atacama-Factsheet-ENG.pdf" target="_blank" rel="noopener noreferrer">
              <ContentfulText content={siteSettings?.footerFactSheetText} fallback={t('footer:links.factSheet')} />
            </a>
            */
            }
          </ul>
        </div>

        <div className='footer-item footer-item--newsletter-wrapper'>
          <form
            // @ts-ignore
            token="31a2fcc2-09b6-40d1-b8b7-163355599ab8"
            id='revinate_contact_api_form'
            className="footer-item--newsletter"
            onSubmit={submitToAll}
          >
            <input type="email" placeholder={t('footer:newsletter.buttonText' as any)} name='email' required onChange={handleInputChange} value={email} />
            <button className="footer-newsletter-link" type='submit'>
              <svg width="33" height="12" viewBox="0 0 33 12" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M25.1791 11.5869C25.5306 11.4521 26.0411 11.7429 25.5834 11.9328C25.503 11.9628 25.6697 11.699 25.5513 11.7087C25.3463 11.721 25.3589 12.0735 25.1052 11.9861C25.0641 11.9685 25.1603 11.5989 25.1791 11.5869ZM23.1347 0.00700718C23.1473 0.0195985 23.1713 0.0482594 23.1972 0.079702C23.2231 0.11068 23.2528 0.146746 23.2885 0.183694C23.317 0.171181 23.3512 0.160191 23.398 0.159663C23.5071 0.1618 23.5089 0.241658 23.48 0.336892C23.6046 0.412783 23.8185 0.503158 23.973 0.558027C24.018 0.471948 24.0589 0.428205 24.1627 0.524349C24.1683 0.5327 24.1249 0.58073 24.117 0.618244C24.1951 0.663889 24.2487 0.720316 24.3516 0.738635C24.3696 0.739738 24.4023 0.632581 24.4089 0.631011C24.5965 0.572335 24.417 0.789721 24.4221 0.847905C24.4224 0.850048 24.4224 0.852625 24.4226 0.854748C24.547 0.934211 24.6729 1.01107 24.7972 1.08953C24.8992 0.999003 25.0348 0.87251 25.0881 0.879484C25.1933 0.893795 25.1013 1.00794 25.2155 1.02018C25.2251 1.02123 25.2575 0.940788 25.3171 0.970285C25.5961 1.10791 25.8949 1.28367 26.2036 1.39258C26.2459 1.40785 26.2426 1.257 26.3033 1.27641C26.5905 1.36846 26.8997 1.48659 27.157 1.64473C27.1656 1.65009 27.1719 1.65616 27.176 1.66267C27.1987 1.70309 27.1467 1.76507 27.15 1.79303C27.1793 1.98858 27.3904 1.79036 27.411 1.79184C27.9475 1.83661 28.2867 2.17144 28.8608 2.21676C28.8938 2.21779 29.1923 2.01859 29.2341 2.27151C29.2371 2.28845 29.2759 2.54712 29.4089 2.41375C29.4172 2.40539 29.3859 2.26963 29.494 2.31206C29.6017 2.35429 29.8034 2.32357 29.9218 2.49629C29.9605 2.55113 30.0101 2.81218 30.2087 2.67014C30.2209 2.65965 30.5654 2.30908 30.5666 2.61774C30.5666 2.66866 30.4663 2.96672 30.6882 2.86305C30.7301 2.84258 30.6887 2.75735 30.7893 2.74115C30.947 2.71689 31.1057 2.85187 31.3213 2.77355C31.3605 2.75991 31.555 2.59817 31.616 2.78944C31.6247 2.81919 31.5594 2.9086 31.6118 2.93891C31.8713 3.09497 32.1526 3.09393 32.5726 3.43379C32.7489 3.59323 32.5359 3.62316 32.741 3.88778C32.7847 3.95005 32.8613 4.05364 32.9229 4.21145C33.0007 4.39156 33.0417 4.71365 32.9374 4.97991C32.8221 5.26629 32.7072 5.35275 32.5963 5.45275C32.5132 5.52069 32.4394 5.56719 32.3754 5.60765C32.1719 5.7156 32.1032 5.72543 32.0414 5.75907C31.8398 5.86757 32.0732 6.113 31.8075 6.15811C31.7314 6.16857 31.6578 6.17401 31.5867 6.17977C31.5764 6.29351 31.5649 6.47492 31.4133 6.52102C31.1973 6.57922 30.7887 6.10573 30.7103 6.45267C30.6822 6.58344 31.1286 7.25748 30.6426 7.17811C30.3377 7.62748 29.8253 7.78741 29.4957 8.2296C29.4815 8.25064 29.5539 8.46699 29.5069 8.49984C29.4369 8.54823 29.3385 8.49606 29.2867 8.52737C29.0679 8.65684 28.9348 8.86509 28.7312 8.99997C28.6543 9.05086 28.618 8.94798 28.5259 9.00915C28.4345 9.07051 28.4573 9.22435 28.2981 9.25983C28.178 9.28579 27.9187 9.12721 27.7784 9.19137C27.9397 9.41811 27.8551 9.4738 27.753 9.64371C27.7338 9.67622 27.8226 9.73107 27.8169 9.75055C27.7942 9.83054 27.6955 9.80543 27.6779 9.88717C27.6736 9.90685 27.7298 9.98183 27.7305 10.0029C27.732 10.1784 27.4632 10.1202 27.4152 10.111C27.2349 10.0746 27.2717 10.2041 27.1667 10.2191C27.0625 10.2338 27.1207 10.0944 27.0186 10.1362C27.0045 10.142 26.9903 10.1478 26.9765 10.1545C26.7797 10.27 26.6132 10.4745 26.4718 10.623C26.4119 10.6866 26.5432 10.7283 26.5388 10.7398C26.457 10.8677 26.2937 10.9168 26.291 11.0639C26.2904 11.0981 26.2983 11.1377 26.3171 11.1855C25.7758 10.7971 26.2842 11.3121 25.9842 11.3866C25.9598 11.392 25.7569 11.1596 25.7846 11.0801C25.8112 11.0016 25.9574 11.0028 25.9835 10.8798C25.9864 10.8655 25.964 10.7862 25.939 10.7063C25.9128 10.6216 25.8834 10.5363 25.8836 10.5233C25.8853 10.3261 26.232 10.6214 26.2594 10.6356C26.5227 10.754 26.4178 10.4097 26.4339 10.3586C26.4989 10.1629 26.6408 10.0612 26.7385 9.92102L26.7614 9.90034C26.7791 9.8781 26.7955 9.85408 26.8103 9.82808C26.8768 9.71327 26.6957 9.4706 26.7785 9.41529C27.0548 9.23278 27.3986 9.50114 27.4159 9.02849C27.4208 8.92706 27.171 8.70162 27.5114 8.77097C27.5362 8.77591 27.8097 8.86349 27.799 8.68518C27.7973 8.66256 27.7403 8.58583 27.7483 8.56959C27.8038 8.4632 27.9074 8.4811 27.9793 8.38237C28.0518 8.28276 28.1314 8.15452 28.2569 8.10132C28.3323 8.06935 28.5223 8.15185 28.5791 8.16398C28.7408 8.19974 28.7074 7.96558 28.8525 8.04699C28.9992 8.12847 29.0362 8.39525 29.2374 8.36617C29.0904 8.16355 28.9461 7.95045 28.8009 7.7446C29.1067 7.51939 29.4464 7.35015 29.7144 7.099C29.7472 7.06754 29.6239 6.9975 29.6566 6.96149C29.7919 6.81204 29.9862 6.76138 30.0988 6.59142C30.1858 6.45916 30.1886 6.24209 30.2454 6.113C30.3467 6.1532 30.4176 6.14738 30.4709 6.11989C30.2354 6.08459 30.0053 6.04866 29.7565 6.03514C29.6612 6.02928 29.7347 6.12753 29.5985 6.12562C29.0823 6.11769 28.1986 6.19239 27.7535 5.98379C27.3999 5.81626 27.8458 5.69451 27.5761 5.62543C27.4461 5.59332 27.2953 5.90603 27.2668 5.91581C26.9581 6.01511 26.744 5.87673 26.4595 5.9205C26.4023 5.92961 26.4585 6.05641 26.4103 6.06277C26.2472 6.08553 26.0635 6.03034 25.9065 6.04217C25.8354 6.04781 25.8491 6.14494 25.7831 6.13811C25.6248 6.12293 25.4812 6.08359 25.3281 5.99467C25.3141 5.9864 25.4066 5.86461 25.2903 5.86155C25.0984 5.85748 24.8621 5.77088 24.6438 5.86837C24.5795 5.8979 24.5789 6.12025 24.4376 5.96988C24.4085 5.93695 24.4388 5.67148 24.2833 5.90501C24.2586 5.94389 23.987 6.2626 23.8515 6.06576C23.8153 6.01394 23.7199 5.79782 23.6425 5.83444C23.6333 5.84247 23.6775 5.95778 23.614 5.97142C23.3826 6.01722 23.1506 6.01232 22.9142 6.05795C22.8514 6.07038 22.9493 6.19052 22.8559 6.20538C22.6518 6.23764 22.4087 6.23107 22.1842 6.21325C22.1309 6.20872 22.0787 6.20351 22.0292 6.19793C21.9373 6.18728 21.9961 6.08229 21.989 6.07145C21.8738 5.89558 21.82 6.14245 21.7847 6.15852C21.57 6.25394 21.3909 6.14755 21.1899 6.18859C21.1348 6.19989 21.1798 6.31252 21.1702 6.32525C21.059 6.43291 21.1343 6.21961 21.0591 6.20035C20.8476 6.14633 20.6174 6.16871 20.4086 6.19617C20.3323 6.20641 20.4261 6.33616 20.358 6.34417C19.9488 6.39222 19.5244 6.40661 19.1174 6.35971C19.0412 6.35059 19.0808 6.24321 19.0635 6.22055C18.9442 6.06257 18.8002 6.29988 18.765 6.32401C18.6054 6.43405 18.535 6.34645 18.3889 6.37409C17.6764 6.51063 16.7839 6.51702 16.1001 6.53121C15.2097 6.55019 14.5122 6.50418 13.6651 6.59197C13.6121 6.59789 13.6757 6.73114 13.6302 6.7382C13.0314 6.81534 12.4346 6.80363 11.8321 6.88286C11.7828 6.8891 11.8624 7.01461 11.7836 7.02906C11.6225 7.0595 11.4114 7.06601 11.2449 7.0341C11.1635 7.01853 11.2648 6.89951 11.182 6.88649C10.9883 6.85592 10.7877 6.85873 10.592 6.89066C10.5105 6.9049 10.6422 7.03165 10.5346 7.03913C9.80205 7.09248 9.07081 7.14837 8.31506 6.99224C8.26357 6.98146 8.21027 6.71007 8.10189 6.76449C8.09507 6.84027 8.09669 6.92914 8.09456 7.01003C8.03414 7.01356 7.974 7.01667 7.91447 7.01912C6.90565 7.06063 5.91662 6.98423 4.90463 6.97039C4.8605 6.97011 4.93676 7.11433 4.85141 7.11431C4.34591 7.1119 3.85538 7.14932 3.33613 6.9997C3.28476 6.98503 3.31231 6.73093 3.16308 6.76713C3.13827 6.77389 2.9044 6.80443 2.84795 6.85867C2.83945 6.86686 2.88072 6.98656 2.80544 6.98878C2.37412 6.99966 1.92959 6.96204 1.49863 6.87495C1.43089 6.86056 1.50715 6.73738 1.4591 6.72614C1.11084 6.64722 0.724876 6.72666 0.393332 6.59215C0.172759 6.50134 0.269101 6.28718 0.16431 6.06464C0.149676 6.03348 0.0132237 6.01907 0.013875 5.89404C0.0181736 5.57863 0.109696 5.23874 0.105988 4.90195C0.104046 4.83012 -0.0777697 4.89403 0.0392235 4.7278C0.0509197 4.71692 0.178106 4.66818 0.216506 4.61151C0.240201 4.57208 0.211337 4.44225 0.257754 4.39279C0.306024 4.34353 0.3473 4.45329 0.425279 4.39638C0.501797 4.33848 0.477735 4.19253 0.626122 4.1836C0.966269 4.16405 1.41852 4.22344 1.76273 4.29072C1.86999 4.31168 1.81309 4.38906 1.88901 4.40702C2.03321 4.44173 2.17226 4.40659 2.31772 4.4464C2.36683 4.46001 2.30264 4.5835 2.35436 4.59499C2.63029 4.65639 2.89376 4.62926 3.17886 4.65966C4.5699 4.8088 5.94951 4.84916 7.37422 4.88914C7.53232 4.89362 7.70382 4.9091 7.88467 4.92482C8.21482 4.95532 8.57348 4.98377 8.88446 4.94016C8.93996 4.93181 8.90275 4.82329 8.91311 4.81389C9.07678 4.66965 9.02712 4.89357 9.13721 4.91891C9.5758 5.01823 10.0604 5.00436 10.4761 4.93883C10.6537 4.91054 10.4623 4.70279 10.6491 4.81444C10.6621 4.82197 10.6239 4.9404 10.6731 4.95043C10.7842 4.97211 10.9935 4.93872 11.0811 4.94256C11.2472 4.95087 11.2744 4.94872 11.4314 4.94018C11.6463 4.92947 11.9057 4.97055 12.1334 4.92871C12.182 4.91943 12.1093 4.8045 12.1861 4.77892C12.2627 4.7535 12.4712 4.74901 12.5425 4.77212C12.614 4.79532 12.5915 4.89085 12.605 4.91192C12.719 5.08622 12.9437 4.81808 12.9733 4.80971C13.5292 4.66386 14.0218 4.77075 14.5513 4.73053C14.9533 4.69965 15.3796 4.61971 15.7628 4.5971C16.219 4.57067 16.6099 4.60599 17.0524 4.56182C17.099 4.5573 17.0345 4.42189 17.0912 4.41588C17.6973 4.35426 18.3028 4.32509 18.9154 4.37818C18.9764 4.38382 18.907 4.51226 18.9686 4.52508C19.3485 4.60053 19.9474 4.80569 20.1376 4.25625C20.3901 4.26177 20.6995 4.26568 20.931 4.36142C21.081 4.42312 20.9471 4.56487 21.1228 4.4981C21.1619 4.48293 21.1039 4.36876 21.1633 4.35519C21.4162 4.29883 21.6962 4.32413 21.9477 4.25253C21.9984 4.23765 21.9801 4.13254 21.9938 4.11295C22.0236 4.07214 22.0596 4.05833 22.0976 4.0603C22.2099 4.06588 22.3364 4.20349 22.3703 4.21657C22.7095 4.34144 22.9605 4.27872 23.2701 4.2722C23.3413 4.27035 23.2528 4.13168 23.3216 4.12524C23.6905 4.09339 24.0681 4.09598 24.4225 4.15094C24.5004 4.1639 24.4315 4.28442 24.469 4.29735C24.64 4.3496 24.673 4.12143 24.8335 4.16762C24.8669 4.17743 24.8501 4.28065 24.8564 4.29186C24.9541 4.46757 25.0336 4.21575 25.0594 4.20859C25.3749 4.12723 25.578 4.38791 25.8794 4.34781C25.9151 4.34275 25.834 4.2122 25.9344 4.20597C26.6105 4.16371 27.3377 4.20068 28.006 4.31296C28.1073 4.33001 28.0362 4.42478 28.0404 4.43902C28.1419 4.62916 28.2196 4.37782 28.2531 4.36814C28.5196 4.30323 28.7642 4.51911 28.9572 4.22356C28.8794 4.15969 28.8015 4.09962 28.7182 4.06978C28.636 4.04063 28.658 4.1836 28.5996 4.16705C28.441 4.1215 28.3593 3.97955 28.194 3.94458C28.1789 3.94205 28.1549 4.06734 28.109 4.0453C27.7691 3.88488 27.5158 3.66347 27.1699 3.48004C27.0033 3.39185 26.6735 3.29577 26.5071 3.19387C26.4212 3.14147 26.3358 3.07344 26.2506 3.00184C26.1743 3.00963 26.0781 3.00613 26.0673 3.00194C25.8135 2.91369 25.5785 2.80015 25.3488 2.68151L25.3478 2.68241C25.2458 2.71878 25.1667 2.64678 25.1106 2.55697C24.847 2.41469 24.5867 2.2706 24.3144 2.14522C24.186 2.10835 24.0606 2.06705 23.9387 2.01832C23.9129 2.04856 23.9014 2.11327 23.8948 2.11429C23.8015 2.09546 23.8048 2.04021 23.8316 1.97055C23.7303 1.92635 23.6316 1.87795 23.5348 1.82515C23.5201 1.85132 23.5146 1.8841 23.5089 1.88743C23.3471 1.97539 23.368 1.76438 23.3708 1.72066C23.3786 1.55903 23.2275 1.67528 23.2337 1.56661C23.2342 1.55636 23.2359 1.5465 23.2388 1.53683C23.2141 1.53348 23.1894 1.53209 23.1645 1.53232C23.1378 1.58766 23.1091 1.63044 23.0618 1.62299C23.004 1.60947 22.9455 1.5902 22.8855 1.5672C22.8649 1.57043 22.8443 1.57498 22.8237 1.57723C22.6328 1.59811 22.531 1.54262 22.5011 1.34726C22.469 1.32236 22.4361 1.2968 22.4041 1.26813C22.3982 1.26374 22.3938 1.25938 22.3905 1.25449C22.2726 1.14678 22.154 1.01387 22.0402 0.847399C21.998 0.75431 21.9773 0.701702 21.952 0.581213C21.9321 0.505928 21.9399 0.279306 22.0768 0.176072C22.3024 0.0257353 22.381 0.086099 22.4678 0.0804042C22.541 0.0876143 22.596 0.0982686 22.6509 0.110431C22.7409 0.131309 22.8272 0.159642 22.9109 0.20254C23.0246 0.262388 23.0897 0.272855 23.1373 0.262996C23.1637 0.241658 23.1841 0.227534 23.1839 0.221695C23.1822 0.145091 23.1934 0.141116 23.2074 0.139779C23.1 -0.0465221 23.1275 0.00728323 23.1347 0.00700718ZM27.2935 9.63999C27.1938 9.60934 27.1236 9.79238 27.2466 9.83009C27.3437 9.86061 27.4158 9.67871 27.2935 9.63999ZM28.4591 8.71633C28.6991 8.72979 28.3464 8.20628 28.2641 8.42574C28.2592 8.43838 28.4451 8.71555 28.4591 8.71633ZM0.613374 6.0248C0.553242 6.16329 0.74983 6.18505 0.715345 6.0362C0.713751 6.03024 0.617432 6.01921 0.613374 6.0248ZM29.6105 7.32477C29.4334 7.2769 29.5789 7.59129 29.6528 7.608C29.8978 7.65937 29.7899 7.37071 29.6105 7.32477ZM31.8309 4.58128C31.8594 4.56823 31.7977 4.58485 31.8023 4.58792C31.7991 4.59932 31.7971 4.61021 31.796 4.62053C31.7594 4.58809 31.7282 4.56892 31.6986 4.55986C31.6942 4.58296 31.6878 4.60987 31.6849 4.64152C31.7303 4.85124 31.7763 4.77532 31.7512 4.75534C31.7504 4.74934 31.7815 4.71262 31.8031 4.68233C31.8227 4.73599 31.876 4.76017 31.9187 4.74629C32.0143 4.69921 31.9695 4.64284 31.8669 4.58004C31.8637 4.57041 31.8729 4.56047 31.8309 4.58128ZM31.8216 4.64187C31.8262 4.64785 31.8164 4.66375 31.8031 4.68233C31.7967 4.66474 31.7935 4.6442 31.796 4.62053C31.8039 4.62751 31.8133 4.63364 31.8216 4.64187ZM29.683 4.25858C29.6573 4.25214 29.6345 4.25843 29.6132 4.27191C29.6563 4.27407 29.6995 4.2767 29.7426 4.27854C29.7259 4.27181 29.7063 4.26458 29.683 4.25858ZM31.2256 4.19819C31.1741 4.12067 31.1073 4.21669 31.0307 4.33069C31.0776 4.33341 31.1244 4.33398 31.1708 4.33713C31.1968 4.27102 31.2327 4.21027 31.2256 4.19819ZM22.6346 0.981666C22.7559 0.894738 22.6095 0.776087 22.5549 0.917436C22.5516 0.92276 22.6302 0.986086 22.6346 0.981666Z" fill="%23F3F3F3" /></svg>
            </button>
          </form>
        </div>

        <div className="footer-item footer-item--contact-info">
          <div className="footer-company-info__list">
            <div className="footer-company-info__item">
              <ContentfulText content={siteSettings?.companyName} fallback={t('footer:company.name' as any)} />
            </div>
            <div className="footer-company-info__item">
              <ContentfulText content={siteSettings?.contactEmail} fallback={t('footer:company.email' as any)} />
            </div>
            <div className="footer-company-info__item">
              <ContentfulText content={siteSettings?.contactPhone} fallback={t('footer:company.phone' as any)} />
            </div>
          </div>

          {/* Social Links */}
          <div className="footer-social__list">
            <div className="footer-social__item">
              <a
                href={String(siteSettings?.facebookUrl || "https://www.instagram.com/awasiexperience/")}
                aria-label={t('common:social.followOnFacebook' as any)}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Icon
                  name="instagram"
                  variant={needsDarkIcons ? 'dark' : 'light'}
                  size="custom"
                  width={24}
                  height={24}
                />
              </a>
            </div>
            <div className="footer-social__item">
              <a
                href={String(siteSettings?.linkedinUrl || "https://www.linkedin.com/company/awasiexperience/")}
                aria-label={t('common:social.followOnLinkedIn' as any)}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Icon
                  name="linkedin"
                  variant={needsDarkIcons ? 'dark' : 'light'}
                  size="custom"
                  width={24}
                  height={24}
                />
              </a>
            </div>
            <div className="footer-social__item">
              <a
                href={String(siteSettings?.spotifyUrl || "https://open.spotify.com/user/awasiexperience")}
                aria-label={t('common:social.followOnSpotify' as any)}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Icon
                  name="spotify"
                  variant={needsDarkIcons ? 'dark' : 'light'}
                  size="custom"
                  width={24}
                  height={24}
                />
              </a>
            </div>
          </div>
        </div>

        <div className="footer-item footer-item--logo">
        </div>

        <div className="footer-item footer-item--badges">
          <div className="footer-relais-chateaux-logo"></div>
        </div>

      </div>

    </footer>
  );
};

export default Footer;